class clickTrigger {
  constructor(element) {
    this.button = element;
    this.relatedLink = this.button.parentNode.querySelector("a");
    this.trigger();

    this.button.classList.add("js-click-trigger--processed");
  }

  trigger() {
    this.button.addEventListener("click", () => {
      this.relatedLink.click();
    });
  }
}

const clickButtons = document.querySelectorAll(
  ".js-click-trigger:not(.js-click-trigger--processed)"
);

clickButtons.forEach((button) => {
  button.clickTrigger = new clickTrigger(button);
});
